





















import { Vue, Component, Prop } from "vue-property-decorator";
import { bus } from "../../main";
import QuestionarioDialog from "../Dialogs/QuestionarioDialog.vue";
import * as data from "../../_store/data.module";
import QuestionarioDoc from "../QuestionarioDoc.vue";

@Component({
  components: {
    QuestionarioDialog,
    QuestionarioDoc
  }
})
export default class WorkshopQuestionarioDialog extends Vue {
  @Prop() idRichiesta!: number;
  @Prop() activityType!: string;
  @Prop() soggetto!: string; //entità che visualizza l'elenco documenti
  @Prop() tipoQuestionario!: string;
  @Prop() nomeSoggetto!: string;

  private dialog: boolean;

  private questionario: any;
  private show: boolean;
  private docType: string;

  constructor() {
    super();
    this.dialog = false;
    this.show = true;
    this.questionario = {};
    this.docType = "questionarioWorkshopAzienda";
  }

  close() {
    this.dialog = false;
    bus.$emit("destroyQuestionarioWorkshopDialog");
  }

  created() {
    // bus.$on("closeDocReview", async () => {
    //   this.show = false;
    //   await this.$nextTick();
    //   this.show = true;
    // });
  }
}
